<template>
  <div>
    <b-row>

      <b-col cols="4">
        <b-row>
          <b-col cols="6" >
            <Trend color="white" :width="1" />
          </b-col>
          <b-col cols="6" >
            <Trend name="Figma" icon="UX_UI_Icon" color="red" :width="1" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" >
            <Trend name="Premiere" icon="Premiere_Icon01" color="purple" :width="2" />
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="2">
        <Trend name="UX/UI Design" text="Lorem ipsum dolor sit amet" color="yellow" :width="1" />
      </b-col>

      <b-col cols="2">
        <b-row>
          <b-col cols="12" >
            <Trend name="GitHub" icon="Github_Icon" color="green" :width="1" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" >
            <Trend color="white" :width="1" />
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="4" >
        <Trend name="Premiere" icon="Premiere_Icon01" color="blue" :width="1" />
      </b-col>

    </b-row>

    <b-row>

      <b-col cols="4" >
        <Trend name="Premiere" icon="Premiere_Icon01" color="blue" :width="1" />
      </b-col>
      <b-col cols="2">
        <b-row>
          <b-col cols="12" >
            <Trend name="GitHub" icon="Github_Icon" color="green" :width="1" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" >
            <Trend color="white" :width="1" />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="2" >
        <Trend name="UX/UI Design" icon="Figma-Illu" color="yellow" :width="1" />
      </b-col>
      <b-col cols="4">
        <b-row>
          <b-col cols="6" >
            <Trend name="Figma" icon="UX_UI_Icon" color="red" :width="1" />
          </b-col>
          <b-col cols="6" >
            <Trend color="white" :width="1" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" >
            <Trend name="Premiere" icon="Premiere-Illu" color="purple" :width="2" />
          </b-col>
        </b-row>
      </b-col>

    </b-row>

  </div>
</template>

<script>
import Trend from '@/components/Trend.vue';

export default {
  name: 'TrendsComponent',
  components: {
    Trend,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/text";

.row, .col, .col-1, .col-2, .col-4, .col-6, .col-12 {
  padding: 0;
  margin: 0;
}

</style>
